import * as types from '../_actions/actionTypes';
import _ from 'lodash';

const _systemList = [];

export function TokenReducer(state = { systemList: _systemList }, action) {
  switch (action.type) {
    case types.FETCH_SYSTEMLIST:
      return { systemList: action.payload };
    case types.GEN_TOKEN:
      return { token: action.payload };
    case types.FETCH_SYSTEMLIST_FAILURE:
      return { systemList: _systemList };
    case types.GEN_TOKEN_FAILURE:
      return { systemList: _systemList };
    default:
      return state;
  }
}
